<template>
  <div class="control-group"
        :class="{
          'invalid': input_invalids && input_invalids[input_name],
          'disabled': input_disabled
        }">
      <div :id="input_id" class="control check-group" :class="{'required': input_required}">
          <div v-for="(option, index) in normalized_options"
              :key="'i_c_' + index">
              <input
                type="checkbox"
                :name="input_name"
                :id="`${input_id}_${index}`"
                :required="input_required"
                :disabled="input_disabled"
                :value="option.value"
                v-model="model_value[option.value]"
                @change="onChangeValue">
            <label
              :for="`${input_id}_${index}`">
              {{ tag_text ? Language.say(`${tag_text}${option.label}`) : option.label }}
            </label>
        </div>
      </div>
      <p class="error" v-if="input_invalids && input_invalids[input_name]">
        {{ Language.say(error_text) }}
      </p>
  </div>
</template>

<script setup>
  import {defineProps, defineEmits} from 'vue';
  import {ref, onBeforeMount}       from 'vue';
  import Language                   from '@/js/Shared/Language/Language';

  const props = defineProps({
    input_id: {
      type: String,
      default: '',
    },
    input_name: {
      type: String,
      required: true,
    },
    input_required: {
      type: Boolean,
      default: false
    },
    input_disabled: {
      type: Boolean,
      default: false
    },
    input_invalids: {
      type: Object,
      default : {},
    },
    input_value: {
      type: [Array, Object],
      default: () => {}
    },
    error_text: {
      type: String,
      default: 'global.forms.invalid.input'
    },
    tag_text: {
      type: String,
      default: ''
    },
    options: {
      type: [Array, Object],
      required: true,
    },
  });

  const emit = defineEmits(['change', 'update:input_value']);

  const normalized_options = ref([]);
  const model_value = ref(Array.isArray(props.input_value) ? [...props.input_value] : {...props.input_value});

  onBeforeMount(() => {
    normalized_options.value = normalizedOptions();
  });

  const onChangeValue = ($event) => {
    model_value.value[$event.target.value] = $event.target.checked;
    emit('change', {...model_value.value});
    emit('update:input_value', {...model_value.value});
  }

  const normalizedOptions = () => {
    const options = Array.isArray(props.options) ? props.options : Object.entries(props.options);

    return options.reduce((acc, option) => {
      if (typeof option === 'string') {
        acc.push({ value: option, label: option });
      } else if (Array.isArray(option)) {
        acc.push({ value: option[1], label: option[0] });
      } else {
        acc.push(option);
      }
      return acc;
    }, []);
  }
</script>

